var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.075 5.8325C0.226227 5.16986 0.597983 4.57822 1.12938 4.15446C1.66078 3.73071 2.32033 3.49995 3 3.5H21C21.6797 3.49995 22.3392 3.73071 22.8706 4.15446C23.402 4.57822 23.7738 5.16986 23.925 5.8325L12 13.121L0.075 5.8325ZM0 7.5455V18.2015L8.7045 12.8645L0 7.5455ZM10.1415 13.745L0.2865 19.7855C0.52999 20.2989 0.91429 20.7326 1.39467 21.0362C1.87505 21.3397 2.43176 21.5005 3 21.5H21C21.5681 21.5001 22.1246 21.3389 22.6048 21.0351C23.0849 20.7313 23.4688 20.2975 23.712 19.784L13.857 13.7435L12 14.879L10.1415 13.7435V13.745ZM15.2955 12.866L24 18.2015V7.5455L15.2955 12.8645V12.866Z",
    fill: "#A1B7DE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.5bbfa8efe467edac6a3e1eaf454870b8.svg";
export { ForwardRef as ReactComponent };